import {Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnDestroy} from '@angular/core';
import { SearchService, SEARCH_TYPE_CUENTA, SEARCH_TYPE_COLABORADOR, SEARCH_TYPE_MOTOR } from '../../../../services/search-service';
import { Observable } from 'rxjs/Observable';
import { FormControl } from '@angular/forms';
import { MdDialogRef, MdOptionSelectionChange, DateAdapter } from '@angular/material';
import { ProductoService } from '../../../../services/producto-service';
import {Subject} from 'rxjs/Subject';

@Component({
  selector: 'app-colaborador-autocomplete',
  templateUrl: './colaborador-autocomplete.component.html',
  styleUrls: ['./colaborador-autocomplete.component.scss']
})
export class ColaboradorAutocompleteComponent implements OnDestroy, AfterViewInit {

  @Input('placeholder') placeholder = 'Filtrar por colaborador';
  @Input('singleValue') singleValue = false;
  @Input('onlyMyNetwork') onlyMyNetwork = false;
  @Input('productoSelected') productoSelected = 0;
  @Input('noValues') noValues = false;
  @Input('type') type = 'colaborador';
  @Input('ignoreCurrentUser') ignoreCurrentUser = false;
  // en ocasiones se requiere que colaboradores no aparezcan. almacenamos sus Ids en esta variable
  @Input('colaboradoresToIgnore') colaboradoresToIgnore: number[] = [];

  // Colaboradores
  public colaboradores = [];
  public colabStateControl: FormControl;
  public filteredColaboradores: Observable<any>;
  public selectedColaboradores = [];

  // evento que indica al formulario padre si todos los colaboradores pueden ver el producto elegido
  @Output() validColaboradores = new EventEmitter<{allValid: boolean}>();
  @Output() noValuesEvent = new EventEmitter<{Id: any, Name: any}>();
  @Output() autocompleteChanged = new EventEmitter<{}>();
  @Output() ViewInitialized = new EventEmitter<{}>();

  @Input() showIcon = true;
  destroySubject = new Subject<void>();

  constructor(private searchService: SearchService, private productoService: ProductoService) {
    // Colaboradores
    this.colabStateControl = new FormControl();
    this.filteredColaboradores = this.colabStateControl.valueChanges
        .startWith(null)
        .debounceTime(1000)
        .switchMap(value => {
          if ( (value && value.length > 2) && (!this.singleValue || this.selectedColaboradores.length == 0)){
            return this.searchService.searchAutocomplete(value, SEARCH_TYPE_COLABORADOR);
          } else {
            return Observable.from([[]]);
          }
        })
        .map( value => this.filterValues(value))
        .takeUntil(this.destroySubject);
  }

  ngOnDestroy() {
    this.destroySubject.next();
    this.destroySubject.complete();
  }
  ngAfterViewInit() {
    setTimeout(_ => {
      this.ViewInitialized.emit();
    });
  }

  filterValues(value: any[]): any[] {
    if (this.ignoreCurrentUser) {
      this.colaboradoresToIgnore.push(Number(localStorage.getItem('userId')));
    }
    return value.filter(x => this.colaboradoresToIgnore.indexOf(x.UserId) < 0);
  }

  selectedColaborador(event: MdOptionSelectionChange, value: any) {
    // en ocasiones no queremos que se completen los chips dentro del componente
    // solo enviar el objeto seleccionado al componente padre

    if (this.noValues && event.isUserInput) {
      this.noValuesEvent.emit({Id: value.UserId, Name: value.UserFullName});
      return;
    } else {
      if (this.singleValue && this.selectedColaboradores.length > 0) {
        return;
      }

      if (event.source.selected &&
        this.selectedColaboradores.filter(v => v.UserId === value.UserId).length === 0) {
        this.checkColaborador(value);
        this.selectedColaboradores.push(value);
        this.autocompleteChanged.emit({});
      }
    }


  }

  removeColaborador(col){
    this.selectedColaboradores.splice(this.selectedColaboradores.findIndex(v => v.UserId === col.UserId), 1);
    this.allValid();
  }

  displayFn(value){
    return null;
  }

  // checkear un colaborador
  // al agregar uno nuevo, verificar que todos sean validos y emitir un evento
  // para la validacion del form
  checkColaborador(colaborador) {
    // si en el form no se eligió un producto aun, canView es true
    if (this.productoSelected === 0) {
      colaborador.canViewProduct = true;
    } else {
      this.productoService.getProductosVisibles(colaborador.UserId)
        .subscribe(value => {
          // si no encuentra valores (no hay productos seteados, por lo que ve todos por defecto)
          // devuelve un array con un valor 0
          if (value[0] !== 0) {
            let canView = false;
            value.forEach(x => {
              if (x === this.productoSelected) {
                canView = true;
              }
            });
            colaborador.canViewProduct = canView;
            this.allValid();
          } else {
            colaborador.canViewProduct = true;
          }
        });
    }
  }

  // si se cambia el producto del form, y hay colaboradores seleccionados, volver a checkear
  checkAll() {
    if (this.selectedColaboradores.length) {
      this.selectedColaboradores.forEach(x => {
        this.checkColaborador(x);
      });
    }
  }

  // checkear si todos los colaboradores son validos y emitir un evento
  allValid() {
    let valid = true;
    if (this.selectedColaboradores.length) {
      this.selectedColaboradores.forEach(x => {
        if (x.canViewProduct === false) {
          valid = false;
        }
      });
    }
    this.validColaboradores.emit({allValid: valid});
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/autocomplete/colaborador-autocomplete/colaborador-autocomplete.component.ts